import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box, Text, Link } from "@chakra-ui/react";
import Breadcrumb from "../components/Breadcrumb";

const Hormiguero = () => {
  const { t } = useTranslation('navigation');
  const { t: tContent } = useTranslation('hormiguero');
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  return (
    <Box
      maxWidth={{ base: "100%", md: "800px", lg: "1000px" }}
      margin="0 auto"
      padding="20px"
      paddingTop={{ base: "80px", md: "20px" }}
      textAlign="center"
    >
      {/* Breadcrumb */}
      <Box textAlign="left" mb={4}>
        <Breadcrumb
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.zines'), href: getLocalizedPath('/zines') },
            { label: t('breadcrumbs.hormiguero') }
          ]}
        />
      </Box>

      {/* Title */}
      <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" mb={5}>
        {tContent('title')}
      </Text>

      {/* Description - Shown First */}
      <Box mb="40px">
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description1')}
        </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description2')}
        </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description3')}
        </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description4')}
        </Text>
        <Text
          textAlign="left"
          mb="10px"
          fontFamily="Source Code Pro"
          fontSize={{ base: "md", md: "lg" }}
        >
          {tContent('description5')}
        </Text>
      </Box>

      {/* Interactive zine — embedded from Chapzine (replaces the image carousel).
          Readers flip through the whole zine right here. */}
      <Box w="100%" my={4}>
        <iframe
          src="https://www.chapzine.com/embed/4b051bb3-c0b9-4f45-a82d-0237da3385e6"
          title="Hormiguero — zine"
          loading="lazy"
          style={{ width: "100%", aspectRatio: "3 / 2", border: 0, display: "block" }}
        />
      </Box>

      {/* YouTube Video Link */}
      <Box mt={8} textAlign="left">
        <Text fontSize="sm" fontWeight="normal" color="gray.600">
          {tContent('video.description')}{' '}
          <Link
            href={tContent('video.url')}
            isExternal
            fontWeight="bold"
            color="gray.800"
            _hover={{ textDecoration: 'underline' }}
          >
            {tContent('video.linkText')}
          </Link>
          .
        </Text>
      </Box>
    </Box>
  );
};

export default Hormiguero;
